<template>
  <div class="mt-15 container-inner">
    <h3 class="title-type-2">
      <strong>{{ inventory.name }}</strong> 상품 세부 설정
    </h3>
    <div class="mb-8">
      <h4 class="title-type-3">
        지면설명
        <span class="attention-coment-1 ml-2">
          <v-icon>mdi-alert-circle</v-icon>
          인게임 배너 T마커 상품 이미지 등록 / 특정 CC에 귀속되어 출력됨 (모드에
          따라 나뉨)
        </span>
      </h4>
    </div>
    <v-form v-model="valid" ref="form">
      <!-- 모드 -->
      <div class="mb-8">
        <h4 class="title-type-3">
          모드
          <v-tooltip right content-class="tooltip-custom-1">
            <template v-slot:activator="{ on, attrs }">
              <v-icon class="ml-2" v-bind="attrs" v-on="on"
                >mdi-alert-circle-outline</v-icon
              >
            </template>
            <span>노출 모드 선택 (스트로크, 챔피언십) </span>
          </v-tooltip>
        </h4>
        <div class="relative white rounded pa-6 pr-16">
          <div class="form-row-1">
            <p class="label">
              모드 선택
              <span class="required">
                <v-icon>mdi-check-circle-outline</v-icon>
                필수
              </span>
            </p>
            <div class="write-con">
              <v-select
                :items="searchMode"
                label="선택"
                v-model="selMode"
                item-color="#000"
                class="input-custom-2"
                height="40px"
                solo
                required
                hide-details
              ></v-select>
            </div>
          </div>
          <div class="form-row-1 mt-4" v-if="this.selMode === '챔피언십'">
            <p class="label">
              대회ID
              <span class="required">
                <v-icon>mdi-check-circle-outline</v-icon>
                필수
              </span>
            </p>
            <div class="write-con">
              <v-text-field
                v-model="competitionId"
                label="대회 아이디 값을 직접 입력해주세요."
                class="input-custom-2"
                height="40px"
                solo
                :rules="competitioRules"
                required
              ></v-text-field>
              <p class="form-coment-1 mt-n2">
                <v-icon>mdi-alert-circle-outline</v-icon>
                숫자만 가능합니다.
              </p>
            </div>
          </div>
        </div>
      </div>
      <!-- //모드 -->
      <!-- CC 코스 -->
      <div class="mb-8">
        <h4 class="title-type-3">
          CC 코스
          <v-tooltip right content-class="tooltip-custom-1">
            <template v-slot:activator="{ on, attrs }">
              <v-icon class="ml-2" v-bind="attrs" v-on="on"
                >mdi-alert-circle-outline</v-icon
              >
            </template>
            <span>선택 지면이 노출될 CC 선택</span>
          </v-tooltip>
        </h4>
        <div class="relative white rounded pa-6 pr-16">
          <div class="form-row-1">
            <p class="label">
              CC선택
              <span class="required">
                <v-icon>mdi-check-circle-outline</v-icon>
                필수
              </span>
            </p>
            <div class="write-con">
              <div class="d-flex">
                <div style="height: 48px">
                  <v-radio-group v-model="ccCourse" class="mt-0 pt-2" row>
                    <v-radio
                      label="지정 CC"
                      value="sel"
                      color="#fecd00"
                      class="radio-type-1"
                    ></v-radio>
                  </v-radio-group>
                </div>
                <div v-if="this.ccCourse === 'sel'">
                  <div class="relative">
                    <div class="search-1">
                      <span class="readinput" style="width: 350px">
                        <v-text-field
                          class="input-custom-2"
                          height="40px"
                          min-width="300px"
                          v-model="selCC"
                          hide-details
                          solo
                          readonly
                          @click.stop="openCCcoursePopup"
                        ></v-text-field>
                      </span>
                      <v-btn
                        depressed
                        large
                        max-height="40px"
                        color="#fecd06"
                        class="button-type-1 ml-2"
                        @click.stop="openCCcoursePopup"
                      >
                        찾기
                      </v-btn>
                      <v-btn
                        depressed
                        large
                        max-height="40px"
                        color="#fff"
                        class="button-type-1 ml-2"
                        @click.stop="ccCourseCancel"
                      >
                        취소
                      </v-btn>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--// CC 코스 -->
      <!-- mode cc save btn -->
      <div class="d-flex justify-end mt-10 mb-10">
        <v-btn
          large
          depressed
          max-height="40px"
          color="#fff"
          class="button-type-1"
          @click.stop="cancel"
        >
          취소
        </v-btn>
        <v-btn
          large
          depressed
          max-height="40px"
          color="#fecd06"
          class="button-type-1 ml-4"
          @click.prevent="saveLineItem"
          :disabled="
            !valid || !this.ccCourse || (this.ccCourse === 'sel' && !this.selCC)
          "
        >
          저장
        </v-btn>
      </div>
      <!--// mode cc save btn -->
    </v-form>
    <v-expand-transition>
      <div v-if="lriContent">
        <!-- 홀번호 -->
        <div class="mb-8">
          <h4 class="title-type-3">
            홀번호
            <v-tooltip right content-class="tooltip-custom-1">
              <template v-slot:activator="{ on, attrs }">
                <v-icon class="ml-2" v-bind="attrs" v-on="on"
                  >mdi-alert-circle-outline</v-icon
                >
              </template>
              <span
                >1개의 홀만 선택할 수 있으며, 이미 캠페인이 집행 중인 경우, 동시
                등록은 불가하다. (저장버튼 클릭시 최종 서버 체크)</span
              >
            </v-tooltip>
          </h4>
          <div class="relative white rounded pa-6 pr-16">
            <div class="form-row-1 mb-8">
              <p class="label">홀 개수</p>
              <div class="write-con">
                <div class="d-flex">
                  <p class="num-type-1" v-for="(hole, i) in holes" :key="i">
                    <a
                      href="javascript:void(0);"
                      :class="{
                        active:
                          holeState[i] && holeState[i].state
                            ? holeState[i].state
                            : false,
                        ready:
                          holeState[i] && holeState[i].ready_state
                            ? holeState[i].ready_state
                            : false,
                      }"
                      @click.prevent="holeChecked(hole, i)"
                    >
                      {{ hole.client_key }}
                    </a>
                  </p>
                </div>
              </div>
            </div>
            <div style="min-height: 320px">
              <div v-if="this.activeHole === '1'" key="1">
                <ResourceImage1
                  :propsInventoryType="inventory.type"
                  :propsInventoryId="propsInventoryId"
                  :propsInventory="inventory"
                  :propsLineItemId="lineItemId"
                  :propsLriId="lriId"
                  :propsResources="resources"
                  :propsAdvertiserId="propsAdvertiserId"
                  @getResourceAfterAdd="updateDetailLineitemForResource"
                  @getResourceAfterDelete="deleteDetailLineitemForResource"
                />
              </div>
              <div v-if="this.activeHole === '2'" key="2">
                <ResourceImage1
                  :propsInventoryType="inventory.type"
                  :propsInventoryId="propsInventoryId"
                  :propsInventory="inventory"
                  :propsLineItemId="lineItemId"
                  :propsLriId="lriId"
                  :propsResources="resources"
                  :propsAdvertiserId="propsAdvertiserId"
                  @getResourceAfterAdd="updateDetailLineitemForResource"
                  @getResourceAfterDelete="deleteDetailLineitemForResource"
                />
              </div>
              <div v-if="this.activeHole === '3'" key="3">
                <ResourceImage1
                  :propsInventoryType="inventory.type"
                  :propsInventoryId="propsInventoryId"
                  :propsInventory="inventory"
                  :propsLineItemId="lineItemId"
                  :propsLriId="lriId"
                  :propsResources="resources"
                  :propsAdvertiserId="propsAdvertiserId"
                  @getResourceAfterAdd="updateDetailLineitemForResource"
                  @getResourceAfterDelete="deleteDetailLineitemForResource"
                />
              </div>
              <div v-if="this.activeHole === '4'" key="4">
                <ResourceImage1
                  :propsInventoryType="inventory.type"
                  :propsInventoryId="propsInventoryId"
                  :propsInventory="inventory"
                  :propsLineItemId="lineItemId"
                  :propsLriId="lriId"
                  :propsResources="resources"
                  :propsAdvertiserId="propsAdvertiserId"
                  @getResourceAfterAdd="updateDetailLineitemForResource"
                  @getResourceAfterDelete="deleteDetailLineitemForResource"
                />
              </div>
              <div v-if="this.activeHole === '5'" key="5">
                <ResourceImage1
                  :propsInventoryType="inventory.type"
                  :propsInventoryId="propsInventoryId"
                  :propsInventory="inventory"
                  :propsLineItemId="lineItemId"
                  :propsLriId="lriId"
                  :propsResources="resources"
                  :propsAdvertiserId="propsAdvertiserId"
                  @getResourceAfterAdd="updateDetailLineitemForResource"
                  @getResourceAfterDelete="deleteDetailLineitemForResource"
                />
              </div>
              <div v-if="this.activeHole === '6'" key="6">
                <ResourceImage1
                  :propsInventoryType="inventory.type"
                  :propsInventoryId="propsInventoryId"
                  :propsInventory="inventory"
                  :propsLineItemId="lineItemId"
                  :propsLriId="lriId"
                  :propsResources="resources"
                  :propsAdvertiserId="propsAdvertiserId"
                  @getResourceAfterAdd="updateDetailLineitemForResource"
                  @getResourceAfterDelete="deleteDetailLineitemForResource"
                />
              </div>
              <div v-if="this.activeHole === '7'" key="7">
                <ResourceImage1
                  :propsInventoryType="inventory.type"
                  :propsInventoryId="propsInventoryId"
                  :propsInventory="inventory"
                  :propsLineItemId="lineItemId"
                  :propsLriId="lriId"
                  :propsResources="resources"
                  :propsAdvertiserId="propsAdvertiserId"
                  @getResourceAfterAdd="updateDetailLineitemForResource"
                  @getResourceAfterDelete="deleteDetailLineitemForResource"
                />
              </div>
              <div v-if="this.activeHole === '8'" key="8">
                <ResourceImage1
                  :propsInventoryType="inventory.type"
                  :propsInventoryId="propsInventoryId"
                  :propsInventory="inventory"
                  :propsLineItemId="lineItemId"
                  :propsLriId="lriId"
                  :propsResources="resources"
                  :propsAdvertiserId="propsAdvertiserId"
                  @getResourceAfterAdd="updateDetailLineitemForResource"
                  @getResourceAfterDelete="deleteDetailLineitemForResource"
                />
              </div>
              <div v-if="this.activeHole === '9'" key="9">
                <ResourceImage1
                  :propsInventoryType="inventory.type"
                  :propsInventoryId="propsInventoryId"
                  :propsInventory="inventory"
                  :propsLineItemId="lineItemId"
                  :propsLriId="lriId"
                  :propsResources="resources"
                  :propsAdvertiserId="propsAdvertiserId"
                  @getResourceAfterAdd="updateDetailLineitemForResource"
                  @getResourceAfterDelete="deleteDetailLineitemForResource"
                />
              </div>
              <div v-if="this.activeHole === '10'" key="10">
                <ResourceImage1
                  :propsInventoryType="inventory.type"
                  :propsInventoryId="propsInventoryId"
                  :propsInventory="inventory"
                  :propsLineItemId="lineItemId"
                  :propsLriId="lriId"
                  :propsResources="resources"
                  :propsAdvertiserId="propsAdvertiserId"
                  @getResourceAfterAdd="updateDetailLineitemForResource"
                  @getResourceAfterDelete="deleteDetailLineitemForResource"
                />
              </div>
              <div v-if="this.activeHole === '11'" key="11">
                <ResourceImage1
                  :propsInventoryType="inventory.type"
                  :propsInventoryId="propsInventoryId"
                  :propsInventory="inventory"
                  :propsLineItemId="lineItemId"
                  :propsLriId="lriId"
                  :propsResources="resources"
                  :propsAdvertiserId="propsAdvertiserId"
                  @getResourceAfterAdd="updateDetailLineitemForResource"
                  @getResourceAfterDelete="deleteDetailLineitemForResource"
                />
              </div>
              <div v-if="this.activeHole === '12'" key="12">
                <ResourceImage1
                  :propsInventoryType="inventory.type"
                  :propsInventoryId="propsInventoryId"
                  :propsInventory="inventory"
                  :propsLineItemId="lineItemId"
                  :propsLriId="lriId"
                  :propsResources="resources"
                  :propsAdvertiserId="propsAdvertiserId"
                  @getResourceAfterAdd="updateDetailLineitemForResource"
                  @getResourceAfterDelete="deleteDetailLineitemForResource"
                />
              </div>
              <div v-if="this.activeHole === '13'" key="13">
                <ResourceImage1
                  :propsInventoryType="inventory.type"
                  :propsInventoryId="propsInventoryId"
                  :propsInventory="inventory"
                  :propsLineItemId="lineItemId"
                  :propsLriId="lriId"
                  :propsResources="resources"
                  :propsAdvertiserId="propsAdvertiserId"
                  @getResourceAfterAdd="updateDetailLineitemForResource"
                  @getResourceAfterDelete="deleteDetailLineitemForResource"
                />
              </div>
              <div v-if="this.activeHole === '14'" key="14">
                <ResourceImage1
                  :propsInventoryType="inventory.type"
                  :propsInventoryId="propsInventoryId"
                  :propsInventory="inventory"
                  :propsLineItemId="lineItemId"
                  :propsLriId="lriId"
                  :propsResources="resources"
                  :propsAdvertiserId="propsAdvertiserId"
                  @getResourceAfterAdd="updateDetailLineitemForResource"
                  @getResourceAfterDelete="deleteDetailLineitemForResource"
                />
              </div>
              <div v-if="this.activeHole === '15'" key="15">
                <ResourceImage1
                  :propsInventoryType="inventory.type"
                  :propsInventoryId="propsInventoryId"
                  :propsInventory="inventory"
                  :propsLineItemId="lineItemId"
                  :propsLriId="lriId"
                  :propsResources="resources"
                  :propsAdvertiserId="propsAdvertiserId"
                  @getResourceAfterAdd="updateDetailLineitemForResource"
                  @getResourceAfterDelete="deleteDetailLineitemForResource"
                />
              </div>
              <div v-if="this.activeHole === '16'" key="16">
                <ResourceImage1
                  :propsInventoryType="inventory.type"
                  :propsInventoryId="propsInventoryId"
                  :propsInventory="inventory"
                  :propsLineItemId="lineItemId"
                  :propsLriId="lriId"
                  :propsResources="resources"
                  :propsAdvertiserId="propsAdvertiserId"
                  @getResourceAfterAdd="updateDetailLineitemForResource"
                  @getResourceAfterDelete="deleteDetailLineitemForResource"
                />
              </div>
              <div v-if="this.activeHole === '17'" key="17">
                <ResourceImage1
                  :propsInventoryType="inventory.type"
                  :propsInventoryId="propsInventoryId"
                  :propsInventory="inventory"
                  :propsLineItemId="lineItemId"
                  :propsLriId="lriId"
                  :propsResources="resources"
                  :propsAdvertiserId="propsAdvertiserId"
                  @getResourceAfterAdd="updateDetailLineitemForResource"
                  @getResourceAfterDelete="deleteDetailLineitemForResource"
                />
              </div>
              <div v-if="this.activeHole === '18'" key="18">
                <ResourceImage1
                  :propsInventoryType="inventory.type"
                  :propsInventoryId="propsInventoryId"
                  :propsInventory="inventory"
                  :propsLineItemId="lineItemId"
                  :propsLriId="lriId"
                  :propsResources="resources"
                  :propsAdvertiserId="propsAdvertiserId"
                  @getResourceAfterAdd="updateDetailLineitemForResource"
                  @getResourceAfterDelete="deleteDetailLineitemForResource"
                />
              </div>
            </div>
          </div>
        </div>
        <!--// 홀번호 -->
      </div>
    </v-expand-transition>
    <div v-if="this.searchCCcourse">
      <SearchCCModal
        v-model="searchCCcourse"
        @select:ccCourse="selectCCcourse"
      />
    </div>
    <SystemAlert v-model="showSystemAlert">
      <div slot="noti-text" v-html="logResult"></div>
      <div slot="noti-btns">
        <v-btn
          large
          depressed
          max-height="40px"
          min-width="104px"
          color="#fecd06"
          class="button-type-1"
          @click.stop="showSystemAlert = false"
        >
          확인
        </v-btn>
      </div>
    </SystemAlert>
  </div>
</template>

<script>
import bus from '@/utils/bus';
import SystemAlert from '~@/modal/SystemAlert.vue';
import { toISOFormattedDate } from '@/utils/validation';
import { optionsList } from '@/api/options';

import {
  getDetailCampaignLineItem,
  updateDetailCampaignLineItem,
  addOptionItem,
  updateOptionItem,
} from '@/api/campaign';
import ResourceImage1 from './resourceImage1.vue';
import SearchCCModal from '~@/modal/SearchCCModal.vue';

export default {
  components: {
    ResourceImage1,
    SystemAlert,
    SearchCCModal,
  },
  props: {
    propsInventory: Object,
    propsInventoryId: String,
    propsLineItem: Object,
    propsDateRange: Object,
    propsAdvertiserId: String,
  },
  data: () => ({
    valid: false,
    lriContent: false,

    showSystemAlert: false,
    logResult: '',

    searchMode: [],
    selMode: '',
    optionsModeMap: {},
    competitionId: '',
    competitioRules: [
      v => !!v || '대회 아이디를 입력해주세요.',
      v => (v && /^[0-9]+$/.test(v)) || '숫자만 가능합니다.',
    ],

    searchCC: [],
    ccCourse: 'sel',
    selCC: '',
    optionsCCMap: {},
    isShowAllCC: true,
    isShowSelCC: true,

    isValid: 'Y',

    options: [],
    optionItemsMap: {},

    lineItem: {},
    lineItemId: '',
    lris: [],
    lri: {},
    lriId: '',
    lrisMap: {},

    resources: [],
    defaultResource: {
      dateRange: { startDate: null, endDate: null },
      id: '',
      name: '',
      start_at: null,
      end_at: null,
      is_valid: '',
      type: 1,
      hash: '',
      file: '',
    },
    resourceId: '',

    holes: [],
    holeState: [],
    holesMap: {},
    activeHole: '1',
    existHoles: [],
    searchCCcourse: false,
  }),
  computed: {
    inventory: {
      get() {
        return this.propsInventory;
      },
      set(value) {
        this.propsInventory = value;
      },
    },
    defaultStartAt() {
      return this.propsInventory.start_at;
    },
    defaultEndAt() {
      return this.propsInventory.end_at;
    },
  },
  methods: {
    openCCcoursePopup() {
      this.searchCCcourse = true;
    },
    selectCCcourse(data) {
      this.selCC = data.name;
    },
    ccCourseCancel() {
      this.selCC = '';
    },
    async getOptions() {
      try {
        const { data } = await optionsList();
        this.options = data.list;
        const modeMap = {};
        const ccMap = {};
        const optionItemsArray = [];
        const optionItemsMap = {};
        (this.options || []).forEach(option => {
          if (option.name === '모드' && !option.key) {
            option.items.forEach(item => {
              modeMap[item.name] = item;
            });
          }
          if (option.name === 'CC 코스' && !option.key) {
            option.items.forEach(item => {
              ccMap[item.name] = item;
            });
          }

          if (option.name === '홀번호' && !option.key) {
            option.items.forEach((item, i) => {
              this.holes[i] = item;
              this.holes[i].active = false;
              this.holes[i].stateActiveNum = i;
              this.holeState.push({
                state: false,
                ready_state: false,
                holeId: item.id,
              });
            });
          }

          option.items.forEach(item => {
            optionItemsArray.push(item);
          });
        });

        (optionItemsArray || []).forEach(item => {
          optionItemsMap[item.id] = item;
        });

        this.optionsModeMap = modeMap;
        this.optionsCCMap = ccMap;

        this.searchMode = Object.keys(modeMap);
        this.searchCC = Object.keys(ccMap);

        this.optionItemsMap = optionItemsMap;
      } catch (error) {
        console.log(error.response);
      }
    },

    //처음 페이지 로딩 시 라인아이템 블러오기
    async getDetailLineItem() {
      const campaignId = this.$route.params.id;
      const inventoryId = this.propsInventoryId;
      const LineItemId = this.propsLineItem.id;
      try {
        const { data } = await getDetailCampaignLineItem(
          campaignId,
          inventoryId,
          LineItemId,
        );

        //lineItem과 lineItemId를 세팅한다.
        this.lineItem = data.row.medias[0].inventories[0].lineitems[0];
        this.lineItemId = data.row.medias[0].inventories[0].lineitems[0].id;

        if (this.lineItem.lris.length > 0) {
          this.lriContent = true;
          //lirs 세팅
          this.lris = this.lineItem.lris;

          //lris에서 존재하는 홀 구하기.
          this.existHoles = [];
          (this.lris || []).forEach(lri => {
            this.existHoles.push(lri.item_id);
            this.lrisMap[lri.item_id] = lri;
          });

          //lri등록과 resource가 있는 홀을 활성화시키고 resource가 있는 lri의 배열을 만든다.
          const hasResourceLri = [];
          this.holes.forEach((hole, i) => {
            if (
              this.existHoles.includes(hole.id) &&
              this.lrisMap[hole.id].resources.length > 0
            ) {
              this.holesMap[hole.id] = hole;
              hole.active = true;
              this.holeState[i].state = true;
              hasResourceLri.push(this.lrisMap[hole.id]);
            }
          });

          if (hasResourceLri.length > 0) {
            this.lriId = hasResourceLri[0].id;
            this.resources = hasResourceLri[0].resources;
            this.activeHole = hasResourceLri[0].client_key;
          }
        }

        //노출정보 세팅
        this.isValid = this.lineItem.is_valid;

        //모드세팅
        if (this.lineItem.mode) {
          this.selMode = this.optionItemsMap[this.lineItem.mode].name;
          this.competitionId = this.lineItem.competition_id;
        } else {
          this.selMode = this.searchMode[0];
        }

        //CC세팅(전체선택 없음)
        if (this.lineItem.cc) {
          this.ccCourse = 'sel';
          this.selCC = this.optionItemsMap[this.lineItem.cc].name;
        }

        bus.$emit('end:spinner');
      } catch (error) {
        bus.$emit('end:spinner');
        console.log(error.response);
      }
    },

    holeChecked(hole, i) {
      //선택한 홀 active. default는 2.
      this.activeHole = hole.client_key;

      //this.existHoles에 등록
      this.existHoles = [];
      this.lris.forEach(lri => {
        this.existHoles.push(lri.item_id);
        this.lrisMap[lri.item_id] = lri;
      });

      //리소스는 없지만 선택하고 입력할 홀에 대해서는 state를 true로 만듦.
      this.holeState.forEach(item => {
        if (item.holeId === hole.id) {
          item.ready_state = true;
        } else {
          item.ready_state = false;
        }
      });

      //데이터 있는 홀 active하게 표시
      this.holes.forEach((hole, i) => {
        if (
          this.existHoles.includes(hole.id) &&
          this.lrisMap[hole.id].resources.length > 0 &&
          this.lrisMap[hole.id].resources[0].id
        ) {
          hole.active = true;
          this.holeState[i].state = true;
        }
      });

      if (this.existHoles.includes(hole.id)) {
        if (
          this.lrisMap[hole.id].resources.length > 0 &&
          this.lrisMap[hole.id].resources[0].id
        ) {
          this.lri = this.lrisMap[hole.id];
          this.lriId = this.lrisMap[hole.id].id;
          this.resources = this.lrisMap[hole.id].resources;
        } else {
          this.lri = this.lrisMap[hole.id];
          this.lriId = this.lrisMap[hole.id].id;

          this.resources = [];
          this.defaultResource.dateRange.startDate = this.defaultStartAt;
          this.defaultResource.dateRange.endDate = this.defaultEndAt;
          this.defaultResource.start_at = this.defaultStartAt;
          this.defaultResource.end_at = this.defaultEndAt;
          this.resources.push(JSON.parse(JSON.stringify(this.defaultResource)));
        }
      } else {
        this.lri = {};
        this.lriId = '';
        this.resources = [];
        this.defaultResource.dateRange.startDate = this.defaultStartAt;
        this.defaultResource.dateRange.endDate = this.defaultEndAt;
        this.defaultResource.start_at = this.defaultStartAt;
        this.defaultResource.end_at = this.defaultEndAt;
        this.resources.push(JSON.parse(JSON.stringify(this.defaultResource)));

        const isExisted = this.existHoles.some(exHole => exHole === hole.id);

        if (!isExisted) {
          let lriData = {
            item_id: hole.id,
          };
          this.addLri(lriData);
        }
      }
    },
    async addLri(lriData) {
      bus.$emit('start:spinner');
      const campaignId = this.$route.params.id;
      const inventoryId = this.propsInventoryId;
      const lineItemId = this.lineItemId;

      try {
        const { data } = await addOptionItem(
          campaignId,
          inventoryId,
          lineItemId,
          lriData,
        );

        if (data.result === 'success') {
          this.lriId = data.value;
          let lri = {
            client_key: this.activeHole,
            id: data.value,
            item_id: lriData.item_id,
            resources: [],
          };
          this.lris.push(lri);
        }
        bus.$emit('end:spinner');
      } catch (error) {
        bus.$emit('end:spinner');
        console.log(error.response);
        const { data } = error.response;
        if (data.result === 'IsAlreadyReserved') {
          this.showSystemAlert = true;
          this.logResult = '선택된 지면은 현재 집행중인 <br>캠페인이 있습니다.';
          await this.getDetailLineItem();
        }
      }
    },

    async updateLri(lriData) {
      const campaignId = this.$route.params.id;
      const inventoryId = this.propsInventoryId;
      const lineItemId = this.lineItemId;
      const lriId = this.lri.id;
      try {
        const { data } = await updateOptionItem(
          campaignId,
          inventoryId,
          lineItemId,
          lriId,
          lriData,
        );
      } catch (error) {
        console.log(error.response);
        const { data } = error.response;
        if (data.result === 'IsAlreadyReserved') {
          this.showSystemAlert = true;
          this.logResult = '선택된 지면은 현재 집행중인 <br>캠페인이 있습니다.';
          await this.getDetailLineItem();
        }
      }
    },

    async saveLineItem() {
      bus.$emit('start:spinner');
      const campaignId = this.$route.params.id;
      const inventoryId = this.propsInventoryId;
      const lineItemId = this.lineItemId;

      let mode = this.selMode
        ? (mode = this.optionsModeMap[this.selMode].id)
        : null;

      let cc = '';
      if (this.ccCourse !== 'all' && this.selCC) {
        cc = this.optionsCCMap[this.selCC].id;
      } else {
        cc = null;
        this.selCC = '';
      }

      let competition_id = '';
      if (this.ccCourse !== 'all' && this.competitionId) {
        competition_id = this.competitionId;
      } else {
        competition_id = null;
      }

      let updateData = {
        is_valid: this.isValid,
        start_at: toISOFormattedDate(new Date(this.propsDateRange.startDate)),
        end_at: toISOFormattedDate(new Date(this.propsDateRange.endDate)),
        mode: mode,
        cc: cc,
        competition_id: competition_id,
      };

      try {
        const { data } = await updateDetailCampaignLineItem(
          campaignId,
          inventoryId,
          lineItemId,
          updateData,
        );
        if (data.result === 'success') {
          this.showSystemAlert = true;
          this.logResult =
            '저장되었습니다.<br>홀을 선택 하신 후 소재 등록 바랍니다.';
        }
        await this.getDetailLineItem();
        this.lriContent = true;

        bus.$emit('end:spinner');
      } catch (error) {
        bus.$emit('end:spinner');
        console.log(error.response);
        const { data } = error.response;
        if (data.result === 'IsAlreadyReserved') {
          this.showSystemAlert = true;
          this.logResult =
            '선택하신 캠페인에 포함된 상품(지면)중 <br>현재 다른 캠페인에서 사용중인 지면이 <br>포함되어 있습니다.<br><br>지면별 일정을 확인 / 수정후<br>다시 시도해주시기 바랍니다.';
        }
      }
    },

    async getDetailLineItemAfterAdd(emitData) {
      const campaignId = this.$route.params.id;
      const inventoryId = this.propsInventoryId;
      const LineItemId = this.propsLineItem.id;
      try {
        const { data } = await getDetailCampaignLineItem(
          campaignId,
          inventoryId,
          LineItemId,
        );
        //lineItem과 lineItemId를 세팅한다.
        this.lineItem = data.row.medias[0].inventories[0].lineitems[0];
        this.lineItemId = data.row.medias[0].inventories[0].lineitems[0].id;

        //등록된 lris를 부른다.
        if (this.lineItem.lris.length > 0) {
          //lirs 세팅
          this.lriContent = true;
          this.lris = this.lineItem.lris;

          //lris에서 존재하는 홀 구하기.
          this.existHoles = [];
          (this.lris || []).forEach(lri => {
            this.existHoles.push(lri.item_id);
            this.lrisMap[lri.item_id] = lri;
          });
          if (emitData) {
            const copy = JSON.parse(JSON.stringify(this.defaultResource));
            copy.type = emitData.resourceType;
            copy.dateRange.startDate = this.defaultStartAt;
            copy.dateRange.endDate = this.defaultEndAt;
            copy.start_at = this.defaultStartAt;
            copy.end_at = this.defaultEndAt;

            this.lris.forEach(lri => {
              if (lri.id === emitData.lriId) {
                this.resources = lri.resources;
                if (this.resources.length === 0) {
                  this.resources.push(copy);
                }
              }
            });
          }
        }
        this.$emit('upadate:campaignInfo');
        bus.$emit('end:spinner');
      } catch (error) {
        bus.$emit('end:spinner');
        console.log(error.response);
      }
    },

    async getDetailLineItemAfterDelete(emitData) {
      const campaignId = this.$route.params.id;
      const inventoryId = this.propsInventoryId;
      const LineItemId = this.propsLineItem.id;
      try {
        const { data } = await getDetailCampaignLineItem(
          campaignId,
          inventoryId,
          LineItemId,
        );

        //lineItem과 lineItemId를 세팅한다.
        this.lineItem = data.row.medias[0].inventories[0].lineitems[0];
        this.lineItemId = data.row.medias[0].inventories[0].lineitems[0].id;

        //등록된 lris를 부른다.
        if (this.lineItem.lris.length > 0) {
          //lirs 세팅
          this.lris = this.lineItem.lris;

          //lris에서 존재하는 홀 구하기.
          this.existHoles = [];
          (this.lris || []).forEach(lri => {
            this.existHoles.push(lri.item_id);
            this.lrisMap[lri.item_id] = lri;
          });

          if (emitData) {
            const copy = JSON.parse(JSON.stringify(this.defaultResource));
            copy.dateRange.startDate = this.defaultStartAt;
            copy.dateRange.endDate = this.defaultEndAt;
            copy.start_at = this.defaultStartAt;
            copy.end_at = this.defaultEndAt;

            let holeId;
            this.lris.forEach(lri => {
              if (lri.id === emitData.lriId) {
                holeId = lri.item_id;
                this.resources = lri.resources;
                if (this.resources.length === 0) {
                  this.resources.push(copy);
                }
              }
            });
            this.holeState.forEach(item => {
              if (item.holeId === holeId) {
                item.state = false;
              }
            });
            //데이터 있는 홀 active하게 표시
            this.holes.forEach((hole, i) => {
              if (
                this.existHoles.includes(hole.id) &&
                this.lrisMap[hole.id].resources.length > 0 &&
                this.lrisMap[hole.id].resources[0].id
              ) {
                hole.active = true;
                this.holeState[i].state = true;
              }
            });
          }
        }
        this.$emit('upadate:campaignInfo');
        bus.$emit('end:spinner');
      } catch (error) {
        bus.$emit('end:spinner');
        console.log(error.response);
      }
    },

    updateDetailLineitemForResource(data) {
      this.getDetailLineItemAfterAdd(data);
    },
    deleteDetailLineitemForResource(data) {
      this.getDetailLineItemAfterDelete(data);
    },
    cancel() {
      this.$emit('close:detail', this.propsInventory);
    },
  },
  async created() {
    bus.$emit('start:spinner');
    await this.getOptions();
    await this.getDetailLineItem();
  },
};
</script>

<style scoped></style>
